// AudioPlaybackContext — estado y handlers de reproducción de audio
// (peticiones y audio_file_id). Aislado del MainAppContext para reducir
// el re-render del subárbol y facilitar testing.
// Creado en Feb 2026 (Fase 3 — Paso 1).
import { createContext, useContext } from "react";

export const AudioPlaybackContext = createContext(null);

export const useAudioPlayback = () => {
  const ctx = useContext(AudioPlaybackContext);
  if (ctx === null) {
    throw new Error("useAudioPlayback debe usarse dentro de <AudioPlaybackContext.Provider>");
  }
  return ctx;
};
